<template>
  <div class="item-box">
    <div class="point-item-view">
      <div v-if="robot.fileName" class="item-img">
        <img :src="robot.basePath + robot.fileName"/>
      </div>
       <div v-else class="empty-img">
        <Icon type="ios-image-outline" size="50" color="#ccc" />
        <br /><span class="empty-word">{{ langMap.empty[lang] }}</span>
      </div>
    </div>
    <div class="modal-container" v-show="showImg"
      :class="{ 'bg-open-animation': showImg, 'bg-close-animation': closeAction }">
      <div class="modal-body" :class="{ 'modal-open-animation': showImg, 'modal-close-animation': closeAction }">
        <div class="modal-box">
          <img :src="require('@/assets/images/qq-group1.jpg')" />
        </div>
        <div class="close-icon" @click="closeModal">{{ langMap.close[lang] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  props: {
    robot: {
      type: Object,
      default: function () {
        return { basePath: '', fileName: '' }
      }
    }
  },
  data() {
    return {
      langMap:langMap,
      showImg: false,
      closeAction: false
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  methods: {
    handleImg() {
      this.showImg = true;
    },
    closeModal() {
      this.closeAction = true;
      setTimeout(() => {
        this.showImg = false;
        this.closeAction = false;
      }, 300);
    }
  },
  mounted() {
    gridRef = this.$refs.gridRef;
    this.getRobots();
    console.log('[info robot]', this.robot);
    gridRef.refreshList(this.dataList);
  }
}
</script>
<style lang="less">
.item-box {
  height: 100%;
}

.point-item-view {
  height: 100%;

}

.item-img {
  margin-left: 10px;
  margin-bottom: 10px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: auto;
  img {
    height: 100%;
    display: block;
  }
}

.empty-img {
  text-align: center;
  position: absolute;
  z-index: 3;
  top: 46%;
  left: 50%;
  margin-left: -25px;
  color: rgba(147, 149, 151, 0.8);

  .empty-word {
    padding: 30px 0;
    font-size: 14px;
  }
}

.modal-container {
  position: fixed;
  background-color: rgba(1, 2, 0, 0.4);
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;

  .modal-body {
    position: absolute;
    left: 50%;
    top: 100px;
    background-color: white;
    margin-left: -270px;
    transform-origin: center;
  }

  .close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 10;
  }
}

.bg-open-animation {
  animation: bg_open 0.3s forwards;
}

.modal-open-animation {
  animation: modal_open 0.3s forwards;
}

.bg-close-animation {
  animation: bg_close 0.3s forwards;
}

.modal-close-animation {
  animation: modal_close 0.3s forwards;
}

@keyframes bg_open {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes modal_open {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bg_close {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes modal_close {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0.8);
  }
}

.modal-box {
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}</style>
